import { Col, Form, Input, Modal, notification, Row } from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { ThemeContext } from '../../../theme/ThemeContext'
import { CheckCircleOutlined, DeleteOutlined } from '@ant-design/icons'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { deletePatientOptionsAsync, getPatientOptionsAsync, savePatientOptionsAsync } from '../../A-toothModule/toothHome/toothHomeSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import styles from './RecipeEditor.module.css'

export const SettingUseMethodModal = (props?: {
  visible?: boolean,
  onOk: () => void,
  onCancel?: () => void,
}): ReactElement => {
  const inputRef = React.useRef<any>(null)

  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [form] = Form.useForm()

  const [dataList, setDataList] = useState<any[]>([])

  const [actionFlag, setActionFlag] = useState<any>()

  const [openEditName, setOpenEditName] = useState(false) //是否打开编辑支付方式的文字以及icon

  const [openEditId, setOpenEditId] = useState<any>() //编辑文字时的id

  useEffect(() => {
    if (props?.visible) {
      getList()
      setTimeout(() => {
        inputRef.current?.focus()
      }, 100);
    }
  }, [props?.visible])

  const getList = () => {
    dispatch(getPatientOptionsAsync({ types: '3' }))
      .then(unwrapResult)
      .then((v: any) => {
        setDataList(v?.[0]?.items || [])
        setTimeout(() => {
          scrollToBottom()
        }, 200);
      })
  }

  useEffect(() => {
    if (!props?.visible) {
      form.resetFields()
      clear()
    }
  }, [props?.visible])

  const row = {
    gutter: 10,
    style: {
      color: theme.tc1,
      fontSize: '1rem',
    },
  }

  const col = {
    style: {
      marginBottom: 10,
      lineHeight: '2rem',
      fontSize: '1rem',
      display: 'flex',
      justifyContent: 'flex-start',
      textAlign: 'center',
      height: '2rem',
    } as React.CSSProperties,
  }

  const submit = (params: any) => {
    dispatch(savePatientOptionsAsync({ type: '3', items: params }))
      .then(unwrapResult)
      .then(() => {
        notification.success({ message: '操作成功' })
        getList()
        form.resetFields()
        clear()
        setTimeout(() => {
          inputRef.current?.focus()
        }, 100);
      })
  }

  const clear = () => {
    setOpenEditId('')
    setOpenEditName(false)
  }

  const scrollToBottom = () => {
    const modalBody: any = document.querySelector('#useMethodModalBody')
    if (modalBody) {
      modalBody.scrollTop = modalBody.scrollHeight
    }
  }

  return (
    <Modal
      title='用法管理'
      maskClosable={false}
      visible={props?.visible}
      width={740}
      footer={null}
      bodyStyle={{ padding: '16px' }}
      // className={styles.useMethodMethodModal}
      onOk={() => {
        props?.onOk() && props?.onOk()
      }}
      onCancel={() => {
        props?.onCancel && props?.onCancel()
      }}
    >
      <div style={{ height: '500px', overflowX: 'hidden', overflowY: 'auto' }} id='useMethodModalBody'>
        <Row {...row}>
          {dataList?.map((v: any) => {
            return (
              <>
                <Col
                  {...col}
                  span={8}
                >
                  <Form.Item>
                    {openEditName && v?.id == openEditId ? (
                      <div style={{ display: 'flex' }}>
                        <Input
                          style={{ fontSize: '1rem' }}
                          onBlur={(e: any) => {
                            setActionFlag(2)
                            if (actionFlag != 1) {
                              clear()
                              if (!e?.target?.value) {
                                notification.info({ message: '请输入用法' })
                                return
                              }
                              const params = [
                                {
                                  id: v?.id,
                                  context: e?.target?.value,
                                  sortNo: v?.sortNo,
                                }
                              ]
                              submit(params)
                            }
                          }}
                          onPressEnter={(e: any) => {
                            setActionFlag(1)
                            clear()
                            if (!e?.target?.value) {
                              notification.info({ message: '请输入用法' })
                              return
                            }
                            const params = [
                              {
                                id: v?.id,
                                context: e?.target?.value,
                                sortNo: v?.sortNo,
                              }
                            ]
                            submit(params)
                          }}
                          maxLength={15}
                          ref={inputRef}
                          onClick={() => {
                            inputRef.current?.select()
                          }}
                          defaultValue={v?.context}
                          className={styles.selectInput}
                          placeholder='用法'
                        />
                        <CheckCircleOutlined
                          style={{
                            fontSize: 19,
                            marginLeft: '10px',
                            position: 'relative',
                            top: 7,
                            color: '#027AFF',
                            cursor: 'pointer',
                          }}
                          onClick={(e: any) => {
                            if (!e?.target?.value) {
                              notification.info({ message: '请输入用法' })
                              return
                            }
                            const params = [
                              {
                                id: v?.id,
                                context: e?.target?.value,
                                sortNo: v?.sortNo,
                              }
                            ]
                            submit(params)
                          }}
                        />
                        <DeleteOutlined
                          style={{
                            color: 'red',
                            fontSize: 19,
                            marginLeft: '10px',
                            position: 'relative',
                            top: 7,
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            Modal.confirm({
                              title: '是否确认删除?',
                              okText: '确认',
                              cancelText: '取消',
                              onOk: () => {
                                dispatch(deletePatientOptionsAsync(v.id))
                                  .then(unwrapResult)
                                  .then((res) => {
                                    notification.success({ message: '删除成功' })
                                    getList()
                                  })
                              },
                            })
                          }}
                        />
                      </div>
                    ) : (
                      <div
                        className={styles.btnStyle}
                        onClick={() => {
                          setOpenEditId(v?.id)
                          setOpenEditName(true)
                        }}
                      >
                        {v?.context}
                      </div>
                    )}
                  </Form.Item>
                </Col>
              </>
            )
          })}
          <Col
            {...col}
            span={8}
            className={styles.inputStyle}
          >
            <Form form={form}>
              <Form.Item label='' name='useMethod' noStyle >
                <Input
                  style={{ fontSize: '1rem' }}
                  onClick={() => {
                    clear()
                  }}
                  onBlur={(v) => {
                    if (!v?.target?.value) {
                      notification.info({ message: '请输入用法' })
                      return
                    }
                    const params = [
                      {
                        id: '',
                        context: v?.target?.value,
                        sortNo: dataList?.length + 1,
                      }
                    ]
                    submit(params)
                  }}
                  onPressEnter={(v: any) => {
                    if (!v?.target?.value) {
                      notification.info({ message: '请输入用法' })
                      return
                    }
                    const params = [
                      {
                        id: '',
                        context: v?.target?.value,
                        sortNo: dataList?.length + 1,
                      }
                    ]
                    submit(params)
                  }}
                  ref={inputRef}
                  maxLength={15}
                  placeholder='请输入用法'
                />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </div>
    </Modal>
  )
}